import React from "react";
import { connect } from "react-redux";
import VeritasHeader from "../../shared/VeritasHeader";
import {Button, Confirm, Grid, Modal, Popup} from "semantic-ui-react";
import {
    deleteDataSource,
    fetchSourceDetailFromID,
    toggleSourceDeleteWarning,
    unmountSourceDetail
} from "../actions/SourceActions";
import SourceDetailInfo from "./SourceDetailInfo";
import {fetchAllServices} from "../../data-services/actions/ServicesActions";
import {closeAddEditModal, openEditModal} from "../../add-edit/actions/AddEditActions";
import DataSourcesForm from "../../add-edit/components/DataSourcesForm";
import {updatedDPSourceRefresh, validateDPSource} from "../../add-edit/actions/AddEditDPSourceActions";
import * as Validation from "../../../common/utils/Validation";
import {toggleApproval} from "../../../middlewares/veritas-middleware/actions/UtilityMiddlewareActions";
import {fetchAllOrganizations} from "../../data-providers/actions/DataProviderActions";
import _ from "lodash";
import SOURCE_TYPES from "../../../common/resources/sourcetypes.json";
import VerifiableElementsTable from "./VerifiableElementsTable";
import Breadcrumb from "../../../common/partials/Breadcrumb";
import { setBreadCrumb } from "../../breadcrumb/BreadcrumbActions";
import INPUT_FIELDS from "../../../common/resources/inputfields.json";
import {fetchAllCountries} from "../../country-coverage/actions/CountriesActions";
import LastUpdated from "../../../common/partials/LastUpdated";
import Sidebar from "../../../common/components/Sidebar";
import VeritasSidebarButtons from "../../shared/VeritasSidebarButtons";

export class DataSourceDetailPage extends React.Component {

    componentDidMount() {
        const {sourceID, resourceType} = this.props.params;
        this.props.getSourceDetail(sourceID, resourceType);
        window.scrollTo(0, 0)

        // If the application reloads at this point, make an API call
        // to get all the services so that for a possible navigation
        // directly to the KYC or KYB Services List page, the data is
        // loaded for rendering.
        if (this.props.all_services.length === 0) {
            this.props.getAllServices();
        }
        if (this.props.all_organizations.length === 0) {
            this.props.getAllOrganizations();
        }
        if (this.props.all_countries.length === 0) {
            this.props.getAllCountries();
        }

        this.props.setBreadCrumb({
            parent: { url: '/veritas', text: 'Veritas' },
            list: { url: '/veritas/kyc-services', text: 'KYC Services' },
            service: { url: `/veritas/kyc-services/`, text: '' },
            source: { url: `/veritas/kyc-services/${sourceID}`, text: '' }
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { sourceID , resourceType} = this.props.params;
        if (this.props.updatedDPSource) {
            this.props.getSourceDetail(sourceID, resourceType);
            // Notifications.showMessage("DP Source created and waiting for approval.");
            this.props.updatedDPSourceRefresh();
        }
        // On creation of a new DP Source from a DP Source detail page, Marvel was not reloading or
        // fetching the data of the newly created DP Source keeping it on the same old Detail Page.
        if (prevProps.params !== this.props.params) {
            const {sourceID, resourceType} = this.props.params;
            this.props.getSourceDetail(sourceID, resourceType);
        }
        const { sourceDetail } = this.props;

        const country = sourceDetail.country ? sourceDetail.country.country_name : '';
        const service = sourceDetail.service;
        document.title = sourceDetail.source_detail ? `Veritas - ${sourceDetail.source_detail.source_type}
        ${sourceDetail.source_detail.source_type_identifier} - ${country}` : '';

        const parentURL = '/veritas';
        const sourceTypeURL = resourceType === 'kyc' ? '/kyc-services' : '/kyb-services';
        const listURL = parentURL + sourceTypeURL

        this.props.setBreadCrumb({
            parent: {
                url: parentURL,
                text: 'Veritas'
            },
            list: {
                url: listURL,
                text: resourceType === 'kyc' ? 'KYC Services' : 'KYB Services'
            },
            service: {
                url: listURL + `/${service ? service.service_id : 'service id missing'}`,
                text: `${service ? service.service_name : 'no service'}`
            },
            source: {
                url: `/veritas/kyc-services/${sourceID}`,
                text: this.props.sourceDetail.service_name
            },
        })
    }

    componentWillUnmount() {
        this.props.unmountSourceDetail();
    }

    handleCloseButtonClick = () => {
        Validation.clearMessages();
        this.props.closeModal("DP Source");
    }

    handleEditButtonClick = () => {
        this.props.openEditModal("DP Source", this.props.sourceDetail);
    }

    deleteButtonClick = () => {
        this.props.toggleSourceDeleteWarning();
    }

    handleSourceApprovalsButtonClick = () => {
        const {sourceDetail, canApprove} = this.props;
        if(canApprove)
            this.props.toggleApproval("dpSource", sourceDetail.approvals);
    }

    get sourceName() {
        const {sourceDetail, canEdit} = this.props;
        const country = sourceDetail.country;
        const lastUpdateOnDate = sourceDetail.source_detail.last_updated;

        const sourceType = _.result(_.find(SOURCE_TYPES, {
            value: sourceDetail.source_detail.source_type
        }), "label");
        const sourceTypeIdentifier = sourceDetail.source_detail.source_type_identifier;

        return(
            <div className="header-container">
                <div className="title-alignment">
                    <span className="detail-name">
                        <h1>
                            {sourceType}{" "}{sourceTypeIdentifier}{" - "}{country ? country.country_name : null}
                        </h1>
                    </span>
                    {canEdit
                        ? (<span className="buttons-alignment">
                            <Popup
                                content={"Edit"}
                                trigger={
                                    <Button
                                        onClick={this.handleEditButtonClick}
                                        icon="edit outline"
                                    />
                                }
                            />
                            <Popup
                                content={"Delete"}
                                trigger={
                                    <Button
                                        onClick={this.deleteButtonClick}
                                        color={"red"}
                                        icon="trash alternate outline"
                                    />
                                }
                            />
                        </span>)
                        : null
                    }
                </div>
                <div className="title-alignment">
                    <span className="detail-config-name">
                        <h3>{sourceDetail.provider.provider_name}{" | "}{sourceDetail.service.service_name}</h3>
                    </span>
                    <span className="buttons-alignment" >
                        <div className="flex">
                            <Button
                                content={sourceDetail.approvals.is_approved === false
                                    ? "Not Approved" : "Approved"}
                                color={sourceDetail.approvals.is_approved === false ? "red" : "green"}
                                onClick={this.handleSourceApprovalsButtonClick}
                            />
                            <label> Last Updated On: </label>
                            <LastUpdated lastUpdated={lastUpdateOnDate}  />
                       </div>
                   </span>
                </div>
                <div>
                    <Button
                        color={sourceDetail.source_detail.status === "Active" ? "green" : "red"}
                        content={sourceDetail.source_detail.status}
                        size="small"
                    />
                </div>
            </div>
        );
    }

    pageContent() {
        return (
            <div style={{padding: "20px 20px 0 20px"}}>
                <Grid relaxed={true}>
                    <Grid.Column width={12}>
                        <Breadcrumb />
                        <div style={{ padding: "20px 20px 0 20px" }}>

                            <div className="header-container">
                                {this.sourceName}
                            </div>
                            {/*Brought out the table from inside the info component*/}
                            {/*grouping them inside one container and rendering it directly made more sense.*/}
                            <div className="detail-container">
                                <SourceDetailInfo
                                    sourceDetail={this.props.sourceDetail}
                                />
                                <VerifiableElementsTable
                                    sourceDetail={this.props.sourceDetail}
                                    dpInputFields={INPUT_FIELDS}
                                />
                            </div>
                        </div>
                    </Grid.Column>
                    <Grid.Column width={4}>
                    </Grid.Column>
                </Grid>
            </div>
        )
    };

    handleEditDPSourceFormSubmit = (e) => {
        e.preventDefault();
        const { sourceObject, toDelete } = this.props;
        const {resourceType} = this.props.params;
        this.props.validateDPSource(sourceObject, resourceType, toDelete);
    }

    handleCancelSourceDelete = () => {
        this.props.toggleSourceDeleteWarning();
    }

    handleConfirmSourceDelete = () => {
        const {sourceDetail} = this.props;
        const {resourceType} = this.props.params;
        this.props.deleteCurrentDataSource(sourceDetail.source_detail.source_id, resourceType);
    }

    render() {
        const {
            dpSourceModalHeader,
            editModalOpenDPSource,
            deleteSourceWarning,
            sourceDetail,
        } = this.props;

        const confirmMessage = Object.keys(sourceDetail).length === 0
            ? ``
            : `Are you sure you want to delete ${sourceDetail.source_detail.source_type}
        ${sourceDetail.source_detail.source_type_identifier} ? This action cannot be undone.`

        return (
            <div className="veritas">
                <VeritasHeader />
                <Grid relaxed={true}>
                    <Grid.Column width={3}>
                        <Sidebar>
                            <VeritasSidebarButtons />
                        </Sidebar>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        {Object.keys(this.props.sourceDetail).length === 0
                            ? null
                            : this.pageContent()
                        }
                    </Grid.Column>
                </Grid>

                <Modal
                    centered={false}
                    open={editModalOpenDPSource}
                >
                    <Modal.Header>
                        {dpSourceModalHeader}
                    </Modal.Header>
                    <Modal.Content scrolling>
                        <DataSourcesForm />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            type="button"
                            color="red"
                            inverted
                            onClick={this.handleCloseButtonClick}
                            content={"Close"}
                        />
                        <Button
                            type="submit"
                            color="green"
                            inverted
                            onClick={e => this.handleEditDPSourceFormSubmit(e)}
                            content={"Submit"}
                        />
                    </Modal.Actions>
                </Modal>

                <Confirm
                    open={deleteSourceWarning}
                    content={confirmMessage}
                    onCancel={this.handleCancelSourceDelete}
                    onConfirm={this.handleConfirmSourceDelete}
                />

            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    canEdit: state.marvel.user.access.accessLevel.isDPEditor,
    canApprove: state.marvel.user.access.accessLevel.isDPAdmin,
    all_services: state.veritas.services.all_services,
    all_countries: state.veritas.countries.all_countries,
    all_organizations: state.veritas.providers.all_organizations,
    sourceDetail: state.veritas.sourceDetail.source,
    dpInputFields: state.veritas.sourceDetail.dpInputFields,
    deleteSourceWarning: state.veritas.sourceDetail.deleteSourceWarning,

    editModalOpenDPSource: state.veritas.addEdit.addEditDPSource.editModalOpenDPSource,
    dpSourceModalHeader: state.veritas.addEdit.addEditDPSource.dpSourceModalHeader,
    sourceObject: state.veritas.addEdit.addEditDPSource.sourceObject,
    toDelete: state.veritas.addEdit.addEditDPSource.toDelete,
    resultsArray: state.veritas.addEdit.addEditDPSource.resultsArray,
    inputsArray: state.veritas.addEdit.addEditDPSource.inputsArray,
    updatedDPSource: state.veritas.addEdit.addEditDPSource.updatedDPSource,
});

const mapDispatchToProps = dispatch => ({
    openEditModal: (type, detailObject) => { dispatch(openEditModal(type, detailObject)) },
    closeModal: (type) => { dispatch(closeAddEditModal(type)) },
    getSourceDetail: (sourceID, sourceType) => { dispatch(fetchSourceDetailFromID(sourceID, sourceType)) },
    getAllServices: () => { dispatch(fetchAllServices()) },
    getAllCountries: () => {dispatch(fetchAllCountries())},
    getAllOrganizations: () => { dispatch(fetchAllOrganizations()) },
    validateDPSource: (sourceObject, resourceType, toDelete) => { dispatch(validateDPSource(sourceObject, resourceType, toDelete)) },
    updatedDPSourceRefresh: () => { dispatch(updatedDPSourceRefresh()) },
    toggleSourceDeleteWarning: () => { dispatch(toggleSourceDeleteWarning()) },
    deleteCurrentDataSource: (sourceID, resourceType) => { dispatch(deleteDataSource(sourceID, resourceType)) },
    unmountSourceDetail: () => { dispatch(unmountSourceDetail()) },
    toggleApproval: (type, approvalsObject) => { dispatch(toggleApproval(type, approvalsObject)) },

    setBreadCrumb: (crumb) => { dispatch(setBreadCrumb(crumb)) },
});


export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DataSourceDetailPage)
